import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { RemoteUpdateUserInputPlanning } from "../../../data/usecases/user-input-planning/remote-update-user-input-planning";
import { FetchState } from "../../../domain/models/fetch-state";
import Swal from "sweetalert2";
import { UpdateUserInputPlanning } from "../../../domain/useages/user-input-planning/update-user-input-planning";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface UpdateUserInputPlanningInterface {
  updateUserInputPlanning: Function;
  updateResponse: Boolean;
  updateStatus: FetchState;
}

const initialStates = {
  updateResponse: false,
  updateStatus: FetchState.DEFAULT,
};

export const useUpdateUserInputPlanningSlice: StateCreator<
  UpdateUserInputPlanningInterface
> = (set) => ({
  ...initialStates,
  updateUserInputPlanning: async (payload: UpdateUserInputPlanning.Params) => {
    set(() => ({ updateStatus: FetchState.LOADING }));

    const axiosHttpClient = AxiosHttpClient.getInstance();
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });
    const remoteUpdateUserInputPlanning = new RemoteUpdateUserInputPlanning(
      `${BASE_URL}${Endpoints.USER_INPUT_PLANNING}`,
      axiosHttpClient
    );

    let result = await remoteUpdateUserInputPlanning.update(payload);
    if (result.success) {
      set(() => ({ updateResponse: true }));
      set(() => ({ updateStatus: FetchState.SUCCESS }));
      return true;
    } else {
      set(() => ({ updateResponse: false }));
      set(() => ({ updateStatus: FetchState.ERROR }));
      Swal.fire({
        icon: "error",
        text: result.errors.message
          ? result.errors.message
          : result.errors.month_year[0],
        confirmButtonColor: "#0D71B7",
        customClass: {
          container: "swal2-style",
        },
      });
      return false;
    }
  },
});
